import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "message-body"
};
var _hoisted_2 = {
  key: 0,
  class: "message-body-nick-name"
};
var _hoisted_3 = {
  class: "content-main"
};
var _hoisted_4 = {
  key: 0,
  class: "content-has-risk-tips"
};
var _hoisted_5 = {
  class: "message-bubble-extra-content"
};
import { computed, toRefs } from '../../../../adapter-vue';
import TUIChatEngine, { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import Icon from '../../../common/Icon.vue';
import ReadStatus from './read-status/index.vue';
import MessageQuote from './message-quote/index.vue';
import Avatar from '../../../common/Avatar/index.vue';
import MessageTranslate from './message-translate/index.vue';
import MessageConvert from './message-convert/index.vue';
import loadingIcon from '../../../../assets/icon/loading.png';
import { shallowCopyMessage } from '../../utils/utils';
import { isPC } from '../../../../utils/env';
var riskImageReplaceUrl = 'https://web.sdk.qcloud.com/component/TUIKit/assets/has_risk_default.png';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-bubble',
  props: {
    messageItem: {
      default: () => ({})
    },
    content: {
      default: () => ({})
    },
    blinkMessageIDList: {
      default: () => []
    },
    classNameList: {
      default: () => []
    }
  },
  emits: ["resendMessage", "blinkMessage", "setReadReceiptPanelVisible", "scrollTo"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emits = __emit;
    var props = __props;
    var TYPES = TUIChatEngine.TYPES;
    var needLoadingIconMessageType = [TYPES.MSG_LOCATION, TYPES.MSG_TEXT, TYPES.MSG_CUSTOM, TYPES.MSG_MERGER, TYPES.MSG_FACE];
    var {
      blinkMessageIDList,
      messageItem: message
    } = toRefs(props);
    var containerClassNameList = computed(() => {
      return ['message-bubble', ...props.classNameList];
    });
    // 当表情删除时，reactionList 会更新对应表情中 totalUserCount
    var hasEmojiReaction = computed(() => {
      var _message$value;
      return (_message$value = message.value) === null || _message$value === void 0 ? void 0 : _message$value.reactionList.some(item => item.totalUserCount !== 0);
    });
    var isNoPadding = computed(() => {
      return !hasEmojiReaction.value && [TYPES.MSG_IMAGE, TYPES.MSG_VIDEO].includes(message.value.type);
    });
    var riskContentText = computed(() => {
      var content = TUITranslateService.t('TUIChat.涉及敏感内容') + ', ';
      if (message.value.flow === 'out') {
        content += TUITranslateService.t('TUIChat.发送失败');
      } else {
        content += TUITranslateService.t(message.value.type === TYPES.MSG_AUDIO ? 'TUIChat.无法收听' : 'TUIChat.无法查看');
      }
      return content;
    });
    var isBlink = computed(() => {
      var _message$value2;
      if ((_message$value2 = message.value) !== null && _message$value2 !== void 0 && _message$value2.ID) {
        var _blinkMessageIDList$v;
        return blinkMessageIDList === null || blinkMessageIDList === void 0 || (_blinkMessageIDList$v = blinkMessageIDList.value) === null || _blinkMessageIDList$v === void 0 ? void 0 : _blinkMessageIDList$v.includes(message.value.ID);
      }
      return false;
    });
    function resendMessage() {
      var _message$value3;
      if (!((_message$value3 = message.value) !== null && _message$value3 !== void 0 && _message$value3.hasRiskContent)) {
        emits('resendMessage');
      }
    }
    function blinkMessage(messageID) {
      emits('blinkMessage', messageID);
    }
    function scrollTo(scrollHeight) {
      emits('scrollTo', scrollHeight);
    }
    function openReadUserPanel() {
      emits('setReadReceiptPanelVisible', true, message.value);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_unref(containerClassNameList))
      }, [_createElementVNode("div", {
        class: _normalizeClass(["message-bubble-main-content", [_unref(message).flow === 'in' ? '' : 'reverse']])
      }, [_createVNode(Avatar, {
        useSkeletonAnimation: "",
        url: _unref(message).avatar || ''
      }, null, 8, ["url"]), _createElementVNode("main", _hoisted_1, [_unref(message).flow === 'in' && _unref(message).conversationType === 'GROUP' ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(props.content.showName), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(['message-body-main', _unref(message).flow === 'out' && 'message-body-main-reverse'])
      }, [_createElementVNode("div", {
        class: _normalizeClass(['blink', _unref(message).type != _unref(TYPES).MSG_FACE ? 'ispadding' : 'ispadding', 'message-body-content', _unref(message).flow === 'out' ? 'content-out' : 'content-in', _unref(message).hasRiskContent && 'content-has-risk', _unref(isNoPadding) ? 'content-no-padding' : '', _unref(isNoPadding) && _unref(isBlink) ? 'blink-shadow' : '', !_unref(isNoPadding) && _unref(isBlink) ? 'blink-content' : ''])
      }, [_createElementVNode("div", _hoisted_3, [(_unref(message).type === _unref(TYPES).MSG_IMAGE || _unref(message).type === _unref(TYPES).MSG_VIDEO) && _unref(message).hasRiskContent ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: _normalizeClass(['message-risk-replace', !_unref(isPC) && 'message-risk-replace-h5']),
        src: riskImageReplaceUrl
      }, null, 2)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_renderSlot(_ctx.$slots, "messageElement"), _renderSlot(_ctx.$slots, "TUIEmojiPlugin")], 64))]), _unref(message).hasRiskContent ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(riskContentText)), 1)) : _createCommentVNode("", true)], 2), _unref(message).status === 'fail' || _unref(message).hasRiskContent ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "message-label fail",
        onClick: _cache[0] || (_cache[0] = $event => resendMessage())
      }, " ! ")) : _createCommentVNode("", true), _unref(message).status === 'unSend' && needLoadingIconMessageType.includes(_unref(message).type) ? (_openBlock(), _createBlock(Icon, {
        key: 1,
        class: "message-label loading-circle",
        file: _unref(loadingIcon),
        width: '15px',
        height: '15px'
      }, null, 8, ["file"])) : _createCommentVNode("", true), _createVNode(ReadStatus, {
        class: "message-label align-self-bottom",
        message: _unref(shallowCopyMessage)(_unref(message)),
        onOpenReadUserPanel: openReadUserPanel
      }, null, 8, ["message"])], 2)])], 2), _createElementVNode("div", _hoisted_5, [_createVNode(MessageTranslate, {
        class: _normalizeClass(_unref(message).flow === 'out' ? 'reverse' : 'flex-row'),
        message: _unref(message)
      }, null, 8, ["class", "message"]), _createVNode(MessageConvert, {
        class: _normalizeClass(_unref(message).flow === 'out' ? 'reverse' : 'flex-row'),
        message: _unref(message)
      }, null, 8, ["class", "message"]), _createVNode(MessageQuote, {
        class: _normalizeClass(_unref(message).flow === 'out' ? 'reverse' : 'flex-row'),
        message: _unref(message),
        onBlinkMessage: blinkMessage,
        onScrollTo: scrollTo
      }, null, 8, ["class", "message"])])], 2);
    };
  }
});